module.exports = function draw_column_number(context, x, y, col_width, col_num, fontsize, right) {
  context.font = fontsize + "px Arial";
  context.textAlign = right ? "right" : "center";
  context.fillStyle = "#666666";
  context.fillText(col_num, x + (col_width / 2), y);
}



//////////////////
// WEBPACK FOOTER
// ./~/biojs-vis-seqlogo/src/render/draw/column_number.js
// module id = 47
// module chunks = 0